import { capitalize } from "lodash";
import moment from "moment";
import React, { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { MdArrowRight } from "react-icons/md";
const BettingHistoryTab = ({ data, key, betCheckObj }) => {
  const [active, setActive] = useState([]);
  return data?.length > 0 ? (
    <tbody id="Matched_Content">
      {data?.map((item) => {
        return (
          <>
            <tr style={{ borderBottom: "thin solid rgba(0,0,0,.12)" }}>
              <td>
                <span
                  style={{
                    color: "#2789ce",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {active.includes(item?._id) ? (
                    <FaMinus
                      style={{ marginRight: "5px" }}
                      onClick={() =>
                        setActive((prev) => {
                          return prev?.filter((res) => {
                            return res !== item?._id;
                          });
                        })
                      }
                    />
                  ) : (
                    <FaPlus
                      style={{ marginRight: "5px" }}
                      onClick={() =>
                        setActive((prev) => {
                          return [...prev, item?._id];
                        })
                      }
                    />
                  )}{" "}
                  {item?.matchBetId || item?.sessionBetId}
                </span>
              </td>
              <td> {item?.casinoBetId || item?.clientName}</td>
              <td
                style={{ textAlign: "start" }}
                className="text-start"
                width="30%"
              >
                <span style={{ textTransform: "uppercase" }}>
                  {betCheckObj[item?.eventType] || item?.platform}
                </span>
                <MdArrowRight size={20} style={{ verticalAlign: "middle" }} />
                <strong>{item?.matchName || item?.casinoName}</strong>
                <MdArrowRight size={20} style={{ verticalAlign: "middle" }} />
                {capitalize(item?.betFaireType) || item?.fancyName}
              </td>
              <td>
                {" "}
                {key === "fancy"
                  ? item?.runnerName
                  : key === "sportBook"
                  ? item?.runnerName
                  : item?.teamName}
              </td>
              <td>
                {" "}
                <span
                  className={
                    item?.betType == "lay" || item?.type == "No"
                      ? "lay-bg"
                      : item?.betType == "back" || item?.type == "Yes"
                      ? "back-bg"
                      : ""
                  }
                  style={{ textTransform: "capitalize" }}
                >
                  {item?.betType || item?.type}
                </span>
              </td>
              <td>
                {moment(item?.timeInserted).format("YYYY-MM-DD hh:mm:ss")}
              </td>
              <td>
                {" "}
                {key === "fancy"
                  ? item?.betRun + "/" + item?.bhav
                  : item?.bhav || "N/A"}
              </td>{" "}
              <td> {item?.amount || "N/A"}</td>
              {/* <td>
                {" "}
                {key === "fancy"
                  ? item?.betRun + "/" + item?.bhav
                  : item?.bhav || "N/A"}{" "}
              </td> */}
              {["fancy", "bookmaker", "betfair"].includes(key) ? (
                <td>
                  {(item?.teamSelectionWin == item?.selectionId &&
                    item?.betType == "back") ||
                  (item?.teamSelectionWin != item?.selectionId &&
                    item?.betType == "lay") ? (
                    <span className="">{item?.profitAmount}</span>
                  ) : (
                    <span className="text-danger">({item?.loseAmount})</span>
                  )}
                </td>
              ) : key === "sportBook" ? (
                <td>
                  {item?.teamSelectionWin &&
                  item?.teamSelectionWin
                    .split(",")
                    .includes(item?.fancySelectionId) ? (
                    <span className="">{item?.profitAmount}</span>
                  ) : (
                    <span className="text-danger">({item?.loseAmount})</span>
                  )}
                </td>
              ) : (
                <td>
                  {item?.type == "No" ? (
                    item?.decisionRun < item?.betRun ? (
                      <span className="">{item?.profitAmount}</span>
                    ) : (
                      <span className="text-danger">({item?.loseAmount})</span>
                    )
                  ) : item?.decisionRun >= item?.betRun ? (
                    <span className="">{item?.profitAmount}</span>
                  ) : (
                    <span className="text-danger">({item?.loseAmount})</span>
                  )}
                </td>
              )}
            </tr>
            {active.includes(item?._id) && (
              <tr className="expand new-bethistory-slip" id={item?._id}>
                {/* <td style={{ background: "#e2e8ed" }} colSpan={"2"}></td> */}
                <td
                  colSpan="10"
                  style={{ background: "#e2e8ed", padding: "0" }}
                  className="new-bethistory-slip-td"
                >
                  <table>
                    <tbody>
                      <tr>
                        <th>Bet Taken</th>
                        <th>Odds req.</th>
                        <th>Stake</th>
                        <th>Liability</th>
                        <th>Odds Matched</th>
                      </tr>
                      <tr
                        id="txRow0"
                        style={{ display: "table-row" }}
                        className="even"
                      >
                        <td>
                          {moment(item?.timeInserted).format(
                            "YYYY-MM-DD hh:mm:ss"
                          )}
                        </td>
                        <td>
                          {key === "fancy"
                            ? item?.betRun + "/" + item?.bhav
                            : item?.bhav || "N/A"}
                        </td>
                        <td> {item?.amount || "N/A"}</td>
                        <td>
                          <span className="text-danger">
                            ({item?.loseAmount})
                          </span>
                        </td>
                        <td>
                          {key === "fancy"
                            ? item?.betRun + "/" + item?.bhav
                            : item?.bhav || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            )}
          </>
        );
      })}
    </tbody>
  ) : (
    <tbody id="Matched_Content">
      <tr
        id="noDataTemplate"
        style={{
          display: "table-row",
        }}
      >
        <td className="no-data" colSpan="9">
          <p>You have no bets in this time period.</p>
        </td>
      </tr>
    </tbody>
  );
};

export default BettingHistoryTab;
